import { render, staticRenderFns } from "./FunnelDeleteModal.vue?vue&type=template&id=50bfd9f9"
import script from "./FunnelDeleteModal.vue?vue&type=script&lang=js"
export * from "./FunnelDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports